__turbopack_context__.v({
  "favoriteButton": "FolderHeaderTitle-module__Y6SEVq__favoriteButton",
  "heading": "FolderHeaderTitle-module__Y6SEVq__heading",
  "icon": "FolderHeaderTitle-module__Y6SEVq__icon",
  "skeletonWrapper": "FolderHeaderTitle-module__Y6SEVq__skeletonWrapper",
  "titleWrapper": "FolderHeaderTitle-module__Y6SEVq__titleWrapper",
});
